

const flags = {  };

export function getFlag(language) {
  return flags[language];
}
